<template>
    <div class="professional-modal">

        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button @click="$emit('close')">
                                <i class="fa fa-close"></i>
                            </button>
                        </div>

                        <div class="modal-body">
                            <img :src="img.path" >
                        </div>

                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
    import linq from 'linq'
    import Vue from 'vue'

    export default {
        name: 'professional-modal',

        data () {
            return {
            }
        },

        props: {
            img: {
                type: Object,
            }
        },

        computed: {

        },

        async created () {

        },

        mounted () {
        },

        methods: {

        },
    }

</script>

<style lang="scss" scoped>
.modal-content {
  height: auto;
}
.modal-dialog {
  width: auto;
}

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .modal-header {
        display: flex;
    }
    .modal-header h2 {
        margin-bottom: 0;
    }
    .modal-header button {
        position: absolute;
        right: 20px;
        top: 0;
        border: 0;
        font-size: 20px;
        background-color: #fff;
    }

    .modal-body {
      margin: 0;
      padding: 0px;
      height: auto;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    @media all and (-ms-high-contrast : none) {

      .modal-dialog {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 35%;
        margin: auto;
      }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/professionalDesign/ProfessionalModal.vue